import { IStairConfig, IStepGeometry, IStringerGeometry } from '@stair-craft/common/util';

import { buildTurnSupports } from '../shared-build-turn-supports/build-turn-supports';
import {
    applyWinderRiserOutlines,
    landingSupports,
    turnSupportOptions,
    winderSupportSteps,
} from '../shared-build-turn-supports/turn-support-steps';
import { IPlanPoint } from '../shared-plan-geometry/plan-geometry';

/**
 * Boards of a U turn. A landing carries them under its three outer edges — side wall, back
 * wall, side wall — from flight 1's edge round to flight 2's. Winders carry them under both the
 * outer and the inner wall, one block per wall segment, cut on the riser lines; each winder
 * riser stops where a board takes over.
 */
export function buildTurnStringers(
    config: IStairConfig,
    turnSteps: IStepGeometry[],
    riserHeight: number,
    treadDepth: number,
    turnStartZ: number,
    entryBottom?: number
): IStringerGeometry[] {
    const options: ReturnType<typeof turnSupportOptions> = turnSupportOptions(config, riserHeight, treadDepth, entryBottom);
    if (config.turnType === 'winder') {
        applyWinderRiserOutlines(turnSteps, true, config);
        return buildTurnSupports(winderSupportSteps(turnSteps, true), options);
    }
    const landing: IStepGeometry | undefined = turnSteps.at(0);
    if (!landing) {
        return [];
    }
    const isRight: boolean = config.turnDirection === 'right';
    const farZ: number = turnStartZ + landing.treadDepth;
    const flight1OuterX: number = isRight ? landing.position.x : landing.position.x + landing.treadWidth;
    const flight2OuterX: number = isRight ? landing.position.x + landing.treadWidth : landing.position.x;
    const wall: IPlanPoint[] = [
        { x: flight1OuterX, z: turnStartZ },
        { x: flight1OuterX, z: farZ },
        { x: flight2OuterX, z: farZ },
        { x: flight2OuterX, z: turnStartZ },
    ];
    return landingSupports(
        landing,
        wall,
        [
            { x: landing.position.x, z: turnStartZ },
            { x: landing.position.x + landing.treadWidth, z: turnStartZ },
        ],
        options
    );
}
